import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const list = async (data) => {
  const url = CONTRACT_MANAGER_URL.CONTRACT
  const result = await bService.post(url, data)

  return result
}

const prepareList = async () => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/prepare-list`
  const result = await bService.get(url)

  return result
}

const initData = async (hotelId) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/init/${hotelId}`

  const result = await bService.get(url)

  return result
}

const initEmail = async (contractId) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/init-email/${contractId}`

  const result = await bService.get(url)

  return result
}

const generateDocument = async (contractId, data) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/generate-document/${contractId}`
  const result = await bService.post(url, data)

  return result
}

const save = async (data) => {
  const url = CONTRACT_MANAGER_URL.CONTRACT
  const result = await bService.put(url, data)

  return result
}

const updateStatus = async (data) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/status`
  const result = await bService.put(url, data)

  return result
}

const detail = async (contractId) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/${contractId}`
  const result = await bService.get(url)

  return result
}

const remove = async (contractId) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/${contractId}`

  const result = await bService.remove(url)

  return result
}

const uploadSignedDocument = async (contractId, data) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/upload-signed-document/${contractId}`

  const result = await bService.post(url, data)

  return result
}

const downloadSignedDocument = async (data) => {
  const contractUrl = CONTRACT_MANAGER_URL.CONTRACT
  const url = `${contractUrl}/download-signed-document`

  const result = await bService.post(url, data)

  return result
}

export default {
  list,
  initData,
  initEmail,
  generateDocument,
  save,
  updateStatus,
  detail,
  remove,
  prepareList,
  uploadSignedDocument,
  downloadSignedDocument
}
